import React, { useEffect, useState } from 'react'
import './App.css'
import './BankDetails.css'
import { Link, useHistory, useLocation } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import { IoCardOutline, IoInformationCircleOutline, IoWarningOutline } from 'react-icons/io5'
import { CheckUserLogin } from './sessions/CheckUserLoggin'
import { BiMenu } from 'react-icons/bi'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

const BankDetails = () => {
  CheckUserLogin()
  const location = useLocation()
  const history = useHistory()

  const { responseMessage, responseCode, bankList } = location.state || {}
  const [bankName, setBankName] = React.useState('N/A')
  const [branchCode, setBranchCode] = React.useState('N/A')
  const [accountNumber, setAccountNumber] = React.useState('N/A')
  const [accountName, setAccountName] = React.useState('N/A')
  const [accountType, setAccountType] = React.useState('N/A')
  const [accountHolder, setAccountHolder] = React.useState('N/A')
  const [createdAt, setCreatedAt] = React.useState('N/A')
  const [message, setMessage] = React.useState('N/A')
  const [error, setError] = React.useState(false)

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)
  const accounttype = localStorage.getItem('accounttype')

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    const businessname = localStorage.getItem('businessname')
    const businessid = localStorage.getItem('businessid')
    document.title = 'Bank details'

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=RETRIEVEBANKDETAILS`, {
      withCredentials: true,
    })
      .then((response) => {
        const data = response.data
        if (data.status === 'failed') {
          setMessage(data.message)
          setError(true)
          console.log('Error: ', data.message)
          return
        }
        const bank_name = data.bank_label.replace('_', ' ')
        if (accounttype === 'customer') {
          setBankName(
            bank_name
              .split(' ')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(' ') ?? 'N/A',
          )
        } else {
          setBankName(data.bank_name)
        }
        setBranchCode(data.branch_code ?? 'N/A')
        setAccountNumber(data.account_number ?? 'N/A')
        setAccountHolder(data.account_holder ?? 'N/A')
        setAccountName(data.account_name ?? 'N/A')
        setAccountType(data.account_type ?? 'N/A')
        setCreatedAt(data.created_at)
      })
      .catch(function (error) {
        console.log('Error: ', error)
      })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [])

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  return (
    <div className="view">
      <Header />
      {accounttype === 'customer' ? (
        <>
          <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
        </>
      ) : accounttype === 'business' ? (
        <>
          <SideNav collapsed={collapsed} onToggle={handleToggle} />
        </>
      ) : (
        <SideNavAff collapsed={collapsed} onToggle={handleToggle} />
      )}

      {/* ✅ Mobile overlay when sidebar is open */}
      {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

      {isMob && collapsed && (
        <label className="mobile-toggle" onClick={handleToggle}>
          <BiMenu size={25} />
        </label>
      )}

      <main
        className="bd-page"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMob ? 0 : collapsed ? '76px' : '252px',
        }}
      >
        <div className="bd-container">
          <div className="bd-top">
            <button type="button" className="bd-back" onClick={() => history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            <Link
              to={{
                pathname: 'edit-b-details',
                state: {
                  accountHolder: accountHolder,
                  accountName: accountName,
                  accountNumber: accountNumber,
                  accountType: accountType,
                  branchCode: branchCode,
                  bankName: bankName,
                  responseCode: responseCode ?? '',
                  bankList: bankList ?? [],
                },
              }}
              className="bd-action"
            >
              {responseMessage && responseCode === 'BANK_DETAILS_MISSING' ? '+ Add' : 'Edit'}
            </Link>
          </div>

          <section className="bd-card">
            <div className="bd-card__head">
              <div className="bd-card__icon">
                <IoCardOutline size={22} />
              </div>
              <h1>Bank details</h1>
            </div>

            <div className="bd-notice-wrap">
              {error && responseCode !== 'BANK_DETAILS_MISSING' ? (
                <div className="bd-notice bd-notice--info">
                  <IoInformationCircleOutline size={20} />
                  <div className="bd-notice__body">
                    <span>{message}</span>
                    <Link
                      to={{
                        pathname: 'edit-b-details',
                        state: {
                          accountHolder: accountHolder,
                          accountName: accountName,
                          accountNumber: accountNumber,
                          accountType: accountType,
                          branchCode: branchCode,
                          bankName: bankName,
                        },
                      }}
                      className="bd-notice__link"
                    >
                      + Add
                    </Link>
                  </div>
                </div>
              ) : (
                <div className="bd-notice bd-notice--warn">
                  <IoWarningOutline size={20} />
                  <div className="bd-notice__body">
                    <strong>Important:</strong>
                    <span>
                      {responseMessage && responseCode === 'BANK_DETAILS_MISSING' ? (
                        <>{responseMessage}</>
                      ) : (
                        'Please ensure that your banking details are correct to avoid any issues with payouts.'
                      )}
                    </span>
                  </div>
                </div>
              )}
            </div>

            <dl className="bd-grid">
              <div className="bd-field">
                <dt>Bank name</dt>
                <dd>{bankName}</dd>
              </div>
              <div className="bd-field">
                <dt>Account holder</dt>
                <dd>{accountHolder}</dd>
              </div>
              <div className="bd-field">
                <dt>Account number</dt>
                <dd>{accountNumber}</dd>
              </div>
              <div className="bd-field">
                <dt>Account type</dt>
                <dd>{accountType}</dd>
              </div>
              <div className="bd-field">
                <dt>Branch code</dt>
                <dd>{branchCode}</dd>
              </div>
              <div className="bd-field">
                <dt>Details created on</dt>
                <dd>{createdAt ? createdAt : 'N/A'}</dd>
              </div>
            </dl>
          </section>
        </div>
      </main>
    </div>
  )
}

export default BankDetails
